import styled from 'styled-components'
import { media, updatedMedia, colors } from 'client/styles'

export const Layout = styled.div`
  ${props => props.background && `background-color: ${colors[props.background]};`}

  .searchForm-container {
    padding-block: 16px 0;
    padding-inline: 20px;

    ${updatedMedia.tablet} {
      padding-block: 40px 0;
      padding-inline: 40px;
    }

    ${media.desktop} {
      padding-block: 0;
      padding-inline: 0;
    }
  }

  ${media.desktop} {
    .searchForm {
      inset-block-start: 400px;
      inset-inline-start: calc(50% - 500px);
      position: absolute;
      width: 1130px;
      background-color: white;
      padding-block: 0;
      padding-inline: 0;
    }
  }

  @media print {
    header {
      display: none !important;
    }

    .noPrint {
      display: none !important;
    }
  }
`
